"use client";

import dynamic from "next/dynamic";

import { useSession } from "@/hooks/use-session";
import { isSuperAdmin } from "@/types/session";

// next/dynamic rather than a static import: the widget pulls in html2canvas,
// and nobody outside the staff should download it with every page.
const InternalFeedback = dynamic(
  () => import("./internal-feedback").then((module) => module.InternalFeedback),
  { ssr: false },
);

/**
 * Renders the feedback widget for the staff the report procedure admits, and
 * hides it while they preview the platform as a customer or as a restricted
 * role, so the preview shows what that audience sees.
 *
 * While impersonating, the session's user is the person being viewed, so the
 * impersonation itself stands in for the role: only admins can start one, and
 * the server checks the impersonator's role before filing anything.
 */
export function InternalFeedbackGate() {
  const { user, session } = useSession();
  const isStaff =
    isSuperAdmin(user) || Boolean(session?.session?.impersonatedBy);

  return isStaff ? <InternalFeedback /> : null;
}
